module.exports = __webpack_public_path__ + "img/logo_pln_login.44780678.svg";